var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.checkLink)?_c('a',{staticClass:"govuk-button govuk-button--neutral",class:{'mr--16': !_vm.inApp},attrs:{"role":"button"},on:{"click":function($event){return _vm.$router.back(-1)}}},[_vm._v("Previous")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }